var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_180",
    "data-name": "Ret\\xE2ngulo 180",
    width: 80,
    height: 80,
    rx: 10,
    fill: "#eeeb",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Folder",
    "data-name": "Iconly Two-tone Folder",
    transform: "translate(18.286 18.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folder-9",
    transform: "translate(0 0.001)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_33957",
    "data-name": "Path 33957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_433",
    "data-name": "Caminho 433",
    d: "M1094.775,583.786H1078.1c-8.594,0-13.931-5.326-13.931-13.9V553.168c0-9.216,4.105-13.89,12.2-13.89h4.286a6.63,6.63,0,0,1,5.28,2.642l1.957,2.6a3.2,3.2,0,0,0,2.544,1.273h6.064c8.347,0,12.235,4.274,12.235,13.454l-.059,10.64C1108.675,578.46,1103.349,583.786,1094.775,583.786Zm-18.407-41.079c-6.151,0-8.773,3.129-8.773,10.462v16.715c0,6.754,3.73,10.473,10.5,10.473h16.677c6.752,0,10.471-3.719,10.471-10.473v-.009l.06-10.638c0-7.3-2.386-10.016-8.807-10.016h-6.066a6.646,6.646,0,0,1-5.282-2.64l-1.959-2.6a3.184,3.184,0,0,0-2.537-1.273Z",
    transform: "translate(-1064.167 -539.278)",
    fill: "#e9e9e9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Line_194",
    "data-name": "Line 194",
    transform: "translate(10.249 26.174)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_434",
    "data-name": "Caminho 434",
    d: "M1090.925,554.158h-20.56a1.714,1.714,0,1,1,0-3.429h20.56a1.714,1.714,0,1,1,0,3.429Z",
    transform: "translate(-1068.651 -550.729)",
    fill: "#fff595"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderDisabled);
export default __webpack_public_path__ + "static/media/folder-disabled.80c20346e95231624897e79a65cfea82.svg";
export { ForwardRef as ReactComponent };